// Yup
import { object, string } from 'yup';

// Helpers
import { isValidCNPJ } from 'helpers/cnpj';

import { addressSchema } from './addressSchema';

const companySchema = object().shape({
  name: string().required('Campo nome obrigatório'),
  cnpj: string()
    .required('Campo CNPJ obrigatório')
    .test('cnpj-valido', 'Digite um CNPJ válido', (value) =>
      isValidCNPJ(value ?? ''),
    ),
  phone: string().matches(/\(\d{2,}\) \d{4,}\-\d{4}/g, {
    message: 'Digite um número válido',
  }),
  email: string().email('Por favor digite um e-mail válido'),
  address: addressSchema,
});

export default companySchema;
export { companySchema };
